// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eZa2","col":"styles_col__3BJf5","actions":"styles_actions__3tvvn","conflict":"styles_conflict__10vAj"};